// extracted by mini-css-extract-plugin
export default {"wrapper":"dashboard_wrapper__sFF9L","header":"dashboard_header__9TIG8","button":"dashboard_button__PHEDT"};